import { Text } from '@mantine/core';
import { DatePickerInput, DatesRangeValue, DateValue } from '@mantine/dates';
import '@mantine/dates/styles.css';
import useValidatedSearchParams from '../../../../router/useValidatedSearchParams';
import { Filter } from './Filters';
import { format, isValid, parse } from 'date-fns';

export const FILTER_DATE_FORMAT_PARSER = 'dd-MM-yyyy'; // date-fns (used by us)
export const FILTER_DATE_FORMAT_INPUT = 'DD-MM-YYYY'; // day-js (used by mantine)

const parseDate = (
  dateStr: string | undefined | number | null
): DateValue | null => {
  if (!dateStr) return null;
  const date = parse(dateStr.toString(), FILTER_DATE_FORMAT_PARSER, new Date());
  return isValid(date) ? date : null;
};

const DateFilter = <T,>({ filter }: { filter: Filter<T> }) => {
  const { setValidatedParam, validatedParams } = useValidatedSearchParams();

  const [min, max] = validatedParams[filter.key]?.split(',') ?? [];

  const handleChange = (value: DatesRangeValue) => {
    const selectedDate = value
      .map((date) => (date ? format(date, FILTER_DATE_FORMAT_PARSER) : null))
      .filter(Boolean)
      .join(',');

    setValidatedParam(filter.key, selectedDate);
  };

  return (
    <DatePickerInput
      size="md"
      type="range"
      valueFormat={FILTER_DATE_FORMAT_INPUT}
      value={[parseDate(min), parseDate(max)]}
      maxDate={new Date()}
      onChange={handleChange}
      allowSingleDateInRange
      label={
        <Text size="lg" mb={8}>
          {filter.label}
        </Text>
      }
      styles={{
        root: {
          flex: 1,
        },
      }}
      clearable
      highlightToday
    />
  );
};

export default DateFilter;
